import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import PropTypes from "prop-types";
import Logo from "../../Images/logo.png";
import "./BondHeader.css";

const BondHeader = ({ title, tagline, address, phone, website }) => {
  return (
    <React.Fragment>
      <div>
        <Row
          className="align-items-center bond-header"
          style={{ margin: "0px 21px 0px 21px" }}
        >
          <Col md={8} className="text-left">
            <div className="bondHeading">
              <h1>{title}</h1>
              <hr />
            </div>
          </Col>
          <Col md={4} className="text-right bondInfo">
            <img src={Logo} alt="Meta F Logo" className="logo-img" />
            <h1>META F</h1>
            <p>{tagline}</p>
            <div className="contact-info">
              <h4 style={{ textAlign: "center" }}>MORE INFORMATION</h4>
              <p>{address}</p>
              <p>{phone}</p>
              <p>{website}</p>
            </div>
          </Col>
        </Row>
        <hr className="bondHorizontal" />
      </div>
    </React.Fragment>
  );
};

export default BondHeader;
